import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import MeetingStatusService from "../../src/Services/MeetingStatus.service";
const MeetingStatusLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        defaultIds: props.defaultIds,
        labelKey: "name",
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<MeetingStatus[]>' is not assignable to type '(ids: string[]) => Promise<MeetingStatus[]>'.
        fetchItemsById: (ids) => {
            return MeetingStatusService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return MeetingStatusService.searchAll(search);
        },
        optionRenderer: function optionRenderer(meetingStatus) {
            return _jsx("span", { children: meetingStatus.name });
        },
    });
};
export default MeetingStatusLookup;
